import React from 'react';
import { Formik } from 'formik';
import GroupDialog from './GroupDialog';
import { filterAssignmentValidationSchema } from './validationSchema';

const DialogWrapper = ({ isModalOpen, handleCloseModal, handleFormSubmit, loading, isEditMode, initialValues, client }) => {
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleFormSubmit}
            enableReinitialize={true}
            isInitialValid={true}
            validateOnMount={false}
            validationSchema={filterAssignmentValidationSchema}
        >
            {(formik) => (
                <GroupDialog
                    open={isModalOpen}
                    onCancel={() => {
                      handleCloseModal();
                      formik.setErrors({});
                      formik.resetForm();
                    }}
                                        submit={() => formik.submitForm()}
                    loading={loading}
                    isEditMode={isEditMode}
                    client={client}
                />
            )}
        </Formik>
    );
};

export default DialogWrapper;
